<template>
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Análise de Eventos de Exames 
        </v-col>
      </v-row>

      <v-card outlined class="mb-4">
        <v-card-text>
          <v-row dense>
          <v-col cols="12" md="4">
            <v-autocomplete
              class="text-uppercase"
              v-model="filters.medicalRequestItemIds"
              :items="medicalRequestItems"
              item-text="name"
              item-value="id"
              label="Procedimentos"
              multiple
              outlined
              dense
              hide-details
              clearable
              chips
              small-chips
              deletable-chips
              />
            </v-col>


            <v-col cols="6" md="3">
            <v-autocomplete
            v-model="filters.eventTypes"
            :items="eventTypeOptions"
            item-text="label"
            item-value="value"
            label="Tipos de evento"
            multiple
            outlined
            dense
            hide-details
            clearable
            chips
            small-chips
            deletable-chips
            no-data-text="Nenhum tipo encontrado"
            >
            <template v-slot:item="{ item }">
            <v-list-item-content>
            <v-list-item-title>{{ item.label }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.value }}</v-list-item-subtitle>
            </v-list-item-content>
            </template>

            <template v-slot:selection="{ item }">
            <v-chip
            small
            close
            class="ma-1"
            @click:close="removeEventType(item.value)"
            >
{{ item.shortLabel }}
</v-chip>
</template>
</v-autocomplete>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                v-model="filters.dateFrom"
                label="Data inicial"
                type="date"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                v-model="filters.dateTo"
                label="Data final"
                type="date"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>

            <v-col cols="2" md="1">
              <v-text-field
                v-model="filters.patientExternalId"
                label="Id Prontuario - Wareline"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>

            <v-col cols="6" md="1">
              <v-text-field
                v-model="filters.attendanceExternalId"
                label="ID atendimento - Wareline"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>



            <v-col cols="12" md="1">
              <v-text-field
                v-model.number="filters.limit"
                label="Limite"
                type="number"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>

            <v-col cols="12" md="1">
              <v-text-field
                v-if="true !=true"
                v-model="filters.examId"
                label="Exam ID"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>


            <v-col cols="12" md="5" class="d-flex align-center">
              <v-btn
                color="light-blue"
                dark
                :loading="$apollo.queries.examEventsAnalysis.loading"
                @click="search"
              >
                Buscar
              </v-btn>

              <v-btn
                text
                class="ml-2"
                @click="clearFilters"
              >
                Limpar
              </v-btn>
              <v-btn
              text
              class="ml-2"
              :disabled="!examEventsAnalysis.length"
              @click="downloadCsv"
              >
              Exportar CSV
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

<v-col cols="12" md="12">
  <v-autocomplete
    v-model="selectedColumns"
    :items="headers"
    item-text="text"
    item-value="value"
    label="Colunas exibidas"
    multiple
    outlined
    dense
    hide-details
    clearable
    chips
    small-chips
  />
</v-col>

      <v-data-table
        :headers="visibleHeaders"
        :items="examEventsAnalysis"
        :loading="$apollo.queries.examEventsAnalysis.loading"
        :items-per-page="100"
          :item-class="rowClass"

        dense
      >
        <template v-slot:item.attendanceCreatedAt="{ item }">
          {{ formatDateTime(item.attendanceCreatedAt) }}
        </template>

        <template v-slot:item.eventCreatedAt="{ item }">
          {{ formatDateTime(item.eventCreatedAt) }}
        </template>

        <template v-slot:item.eventUpdatedAt="{ item }">
          {{ formatDateTime(item.eventUpdatedAt) }}
        </template>

        <template v-slot:item.appraisalSnapshotText="{ item }">
          <span class="snapshot-cell">
            {{ item.appraisalSnapshotText }}
          </span>
        </template>

        <template v-slot:no-data>
          <v-alert color="orange" outlined text type="info">
            Não há eventos encontrados
          </v-alert>
        </template>
      </v-data-table>
    </v-container>
</template>

<script>
export default {
  name: "ExamEventsAnalysis",
  props: {
    medicalReportTemplate: Object,
  },
    data() {
    return {
      shouldFetch: false,
      examEventsAnalysis: [],
      medicalRequestItems: [],
      filters: {
        patientExternalId: "967",
        eventTypes: ["appraisal_created","appraisal_updated", "exam_reopened", "exam_finished"],
        limit: 1000,
        attendanceExternalId: "",
        medicalRequestItemIds: [],
        dateFrom: this.currentMonthStart(),
        dateTo: this.currentMonthEnd(),

      },
selectedColumns: [
                 "attendanceCreatedAt",
                 "attendanceExternalId",
                 "patientExternalId",
                 "requesterName",
                 "patientName",
                 "procedureName",
                 "performerName",
                 "operatorName",
                 "eventDescription",
                 "finishedValue",
                 "cidCode",
                 "cidDescription",
                 "eventCreatedAt"
],
      eventTypeOptions: [
      {
       value: "appraisal_created",
       label: "Laudo iniciado",
       shortLabel: "Laudo iniciado",
      },
      {
       value: "appraisal_updated",
       label: "Laudo atualizado",
       shortLabel: "Laudo atualizado",
      },
      {
       value: "exam_finished",
       label: "Exame finalizado",
       shortLabel: "Exame finalizado",
      },
      {
       value: "exam_reopened",
       label: "Exame reaberto",
       shortLabel: "Exame reaberto",
      },
      ],
      headers: [
        { text: "Unidade", value: "unitName" },
        { text: "Atendimento criado em", value: "attendanceCreatedAt" },
        { text: "Atendimento externo", value: "attendanceExternalId" },
        { text: "Paciente externo", value: "patientExternalId" },
        { text: "Paciente", value: "patientName" },
        { text: "Solicitante", value: "requesterName" },
        { text: "Executante", value: "performerName" },
        { text: "Procedimento", value: "procedureName" },
        { text: "Operador", value: "operatorName" },
        { text: "Tipo evento", value: "eventType" },
        { text: "*Tipo do evento - descritivo", value: "eventDescription" },
        { text: "Exame finalizado?", value: "finishedValue" },
        { text: "Motivo edição", value: "editReason" },
        { text: "Texto laudo", value: "appraisalSnapshotText" },
        { text: "CID", value: "cidCode" },
        { text: "Descrição CID", value: "cidDescription" },
        { text: "Evento criado em", value: "eventCreatedAt" },
        { text: "Evento atualizado em", value: "eventUpdatedAt" },
      ],
    };
  },
  apollo: {
    examEventsAnalysis: {
      query: require("@/graphql/exam_events/exam_events_analysis.gql"),
      variables() {
        return this.queryVariables;
      },
      skip() {
        return !this.shouldFetch;
      },
      fetchPolicy: "network-only",
    },
   medicalRequestItems: {
  query: require("@/components/config/medical_request/item_facilitators/getMedicalRequestItems.gql"),
  variables() {
    return {
      medicalRequestType: "exam",
    };
  },
  fetchPolicy: "network-only",
  update(data) {
    return data.medicalRequestItems || [];
  },
},
  },
  mounted() {
    this.medicalReportTemplates = [];
  },
  watch: {
    medicalReport() {
      this.medicalReportTemplates = [];
    },
  },
  computed: {
              visibleHeaders() {
                return this.headers.filter(header =>
                    this.selectedColumns.includes(header.value)
                    );
              },
    queryVariables() {
      const variables = {};

      Object.keys(this.filters).forEach((key) => {
        const value = this.filters[key];

        if (Array.isArray(value)) {
          if (value.length > 0) variables[key] = value;
          return;
        }

        if (value !== null && value !== undefined && value !== "") {
          variables[key] = value;
        }
      });

      return variables;
    },
  },
  methods: {
    search() {
      this.shouldFetch = true;

      if (this.$apollo.queries.examEventsAnalysis) {
        return this.$apollo.queries.examEventsAnalysis.refetch();
      }
    },

    clearFilters() {
      this.filters = {
        patientExternalId: "",
        eventTypes: [],
        limit: 1000,
        attendanceExternalId: "",
        medicalRequestItemIds: [],
        dateFrom: this.currentMonthStart(),
        dateTo: this.currentMonthEnd(),
      };

      this.examEventsAnalysis = [];
      this.shouldFetch = false;
    },
    downloadCsv() {
  const rows = this.examEventsAnalysis || [];

  const columns = this.headers
    .filter(header => header.value)
    .map(header => ({
      label: header.text,
      value: header.value,
    }));

  const csv = [
    columns.map(column => this.escapeCsv(column.label)).join(";"),
    ...rows.map(row =>
      columns.map(column => this.escapeCsv(row[column.value])).join(";")
    ),
  ].join("\n");

  const blob = new Blob(["\ufeff" + csv], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", `exam-events-analysis-${this.currentDateForFile()}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
},

escapeCsv(value) {
  if (value === null || value === undefined) return "";

  const stringValue = String(value).replace(/"/g, '""');

  return `"${stringValue}"`;
},

currentDateForFile() {
  const date = new Date();

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
},

   currentMonthStart() {
     const date = new Date();
     return this.formatDateInput(new Date(date.getFullYear(), date.getMonth(), 1));
   },

   currentMonthEnd() {
     const date = new Date();
     return this.formatDateInput(new Date(date.getFullYear(), date.getMonth() + 1, 0));
   },

   formatDateInput(date) {
     const year = date.getFullYear();
     const month = String(date.getMonth() + 1).padStart(2, "0");
     const day = String(date.getDate()).padStart(2, "0");

     return `${year}-${month}-${day}`;
   },
    formatDateTime(value) {
      if (!value) return "-";

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) return value;

      return date.toLocaleString("pt-BR");
    },
    removeEventType(value) {
      this.filters.eventTypes = this.filters.eventTypes.filter(
          eventType => eventType !== value
          );
    },
    rowClass(item) {
     const currentIndex = this.examEventsAnalysis.findIndex(
         row => row === item
       );

     const groups = [];
     let currentGroup = 0;
     let lastAttendanceExternalId = null;

     this.examEventsAnalysis.forEach((row) => {
         if (row.attendanceExternalId !== lastAttendanceExternalId) {
         currentGroup += 1;
         lastAttendanceExternalId = row.attendanceExternalId;
         }

         groups.push(currentGroup);
         });

     return groups[currentIndex] % 2 === 0
       ? "attendance-group-even"
       : "attendance-group-odd";
    },
  },
};
</script>

<style lang="scss" scoped>
.snapshot-cell {
  display: inline-block;
  max-width: 360px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep .attendance-group-even  {
  background-color: #e6f0fc !important;
}

::v-deep .attendance-group-odd  {
  background-color: #fff !important;
}
</style>


